import KunLoading61 from './src/index'

KunLoading61.install = function (Vue) {
	Vue.component(KunLoading61.name, KunLoading61);
}

export default KunLoading61;
